import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { BrandLogo } from './BrandLogo';
import { SUPPORT_EMAIL, LEGAL_ENTITY } from '../lib/site';

const COLUMNS = [
  { title: 'Product', links: [{ label: 'Pricing', to: '/pricing' }, { label: 'Templates', to: '/templates' }, { label: 'Features', to: '/features' }] },
  { title: 'Resources', links: [{ label: 'How it works', to: '/how-it-works' }, { label: 'FAQ', to: '/faq' }, { label: 'Resume Builder India', to: '/resume-builder-india' }] },
  { title: 'Company', links: [{ label: 'About', to: '/about' }, { label: 'Contact', to: '/contact' }] },
  { title: 'Legal', links: [{ label: 'Privacy', to: '/privacy' }, { label: 'Terms', to: '/terms' }, { label: 'Refund', to: '/refund-policy' }, { label: 'Cookies', to: '/cookie-policy' }] },
];

export const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer data-testid="site-footer" className="border-t border-border bg-white">
      <div className="mx-auto max-w-[1240px] px-5 py-14 sm:px-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-6">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2" aria-label="Careerova home">
              <span className="logo-mark flex h-9 w-9 items-center justify-center rounded-xl"><BrandLogo className="h-8 w-8 object-contain" /></span>
              <span className="logo-text text-[19px] font-bold tracking-tight">{t('brand.name')}</span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-muted-foreground">Build a resume you can actually send. ATS-friendly templates, AI writing help and job-description matching — in 19 languages.</p>
            <a href={`mailto:${SUPPORT_EMAIL}`} data-testid="footer-support-email" className="mt-5 inline-flex min-h-[40px] items-center gap-2 text-sm font-medium text-primary hover:text-accent">
              <Mail className="h-4 w-4" aria-hidden="true" /> {SUPPORT_EMAIL}
            </a>
          </div>
          {COLUMNS.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h3 className="text-xs font-semibold uppercase tracking-[0.14em] text-muted-foreground">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.to}><Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`} className="inline-flex min-h-[32px] items-center text-sm text-primary/75 transition-colors hover:text-primary">{l.label}</Link></li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
        <div className="mt-12 flex flex-col gap-2 border-t border-border pt-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} {LEGAL_ENTITY}. {t('footer.rights')}</p>
          <p>Careerova does not guarantee interviews or employment.</p>
          <a href="https://db-ip.com" target="_blank" rel="noreferrer" data-testid="footer-geo-attribution" className="hover:underline">IP Geolocation by DB-IP</a>
        </div>
      </div>
    </footer>
  );
};
